// extracted by mini-css-extract-plugin
export default {"navigate-back-text":"NoXltL","navigateBackText":"NoXltL"};